import React from "react"
// import { hot } from "react-hot-loader"
import { HashRouter as Router } from "react-router-dom"
import store from "./store"
import { Provider } from "react-redux"
import { LocaleProvider } from "antd"
import zhCN from "antd/lib/locale-provider/zh_CN"
import "./components/Layout.less"
import "./app.less"
import Header from "./components/Header"
import { renderRoutes, routes } from "./routeConfig"
import Util from "./util/util"

let $rootHtml: HTMLElement | null = document.getElementById("rootHtml")

Util.addEventOnResize(resizeFont)

function resizeFont() {
  let fs = Util.getResizeFontSize(300, 640)
  if (!$rootHtml) {
    return
  }
  $rootHtml.style.fontSize = fs + "px"
}

resizeFont()

function App() {
  return (
    <LocaleProvider locale={zhCN}>
      <Provider store={store}>
        <Router>
          <div
            className={`pg-wrap${window.self === window.top ? "" : " inFrame"}`}
          >
            <Header />
            <div className="pg-main">
              <div className="pg-body">{renderRoutes(routes)}</div>
            </div>
          </div>
        </Router>
      </Provider>
    </LocaleProvider>
  )
}

// export default hot(module)(App)
export default App
